import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '../../guard/auth.guard';
import { MainRoutes } from './main/main.routes';
import { PersonalRoutes } from './personal/personal.routes';
import { ContractsRoutes } from './contracts/contracts.routes';
import { ForSigningRoutes } from './for-signing/for-signing.routes';
import { HistoryRoutes } from './history/history.routes';
import { NotificationsRoutes } from './notifications/notifications.routes';
import { DocumentsRoutes } from './documents/documents.routes';
import { CommunicationsRoutes } from './communications/communications.routes';
import { NotFoundComponent } from '../common/not-found.component';

const ChildRoutes: Array<any> = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  ...MainRoutes,
  ...PersonalRoutes,
  ...ContractsRoutes,
  ...ForSigningRoutes,
  ...HistoryRoutes,
  ...NotificationsRoutes,
  ...CommunicationsRoutes,
  {path: '**', component: NotFoundComponent},
];

export const DashboardRoutes: Array<any> = [
  {
    path: '',
    component: DashboardComponent,
    children: ChildRoutes,
    canActivate: [AuthGuard],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.routes.ts